import { useMemo } from "react";
import { IoPrintOutline } from "react-icons/io5";
import styles from "../../styles/evento-detalle.module.css";
import { useNavigate } from "react-router-dom";


export function TabHabitaciones({ evento, personas, habitacionesCatalogo }) {
    const navigate = useNavigate();
    const rows = useMemo(() => {
        const parts = Array.isArray(evento?.participaciones) ? evento.participaciones : [];

        // Map habId -> { habitacion, ocupantes: [] }
        const map = new Map();

        const getPersonaLabel = (p) => {
            const per = p?.persona || personas.find(x => x.id === p?.personaId);
            if (!per) return String(p?.personaId ?? "—");
            return `${per.nombre} ${per.apellidos}`;
        };

        const addOcupante = (habObj, habId, participante) => {
            if (!habId) return;

            const current = map.get(Number(habId)) || {
                habitacion: habObj || null,
                ocupantes: [],
            };

            current.ocupantes.push({
                id: participante?.id ?? participante?.personaId ?? `${habId}-${current.ocupantes.length}`,
                label: getPersonaLabel(participante),
            });

            // Si no teníamos objeto habitación, intentamos completarlo desde catálogo
            if (!current.habitacion) {
                const fromCatalog = (habitacionesCatalogo || []).find(h => Number(h.id) === Number(habId));
                if (fromCatalog) current.habitacion = fromCatalog;
            }

            map.set(Number(habId), current);
        };

        parts.forEach((p) => {
            // Caso A: detalle trae habitaciones como objetos
            const habsObj = Array.isArray(p?.habitaciones) ? p.habitaciones : [];
            if (habsObj.length) {
                habsObj.forEach((h) => addOcupante(h, h?.id, p));
                return;
            }

            // Caso B: detalle trae habitacionIds (como en form)
            const habIds =
                Array.isArray(p?.habitacionIds) ? p.habitacionIds :
                    Array.isArray(p?.habitaciones) ? p.habitaciones.map(h => h?.id).filter(Boolean) :
                        [];
            habIds.forEach((hid) => addOcupante(null, hid, p));
        });

        // Convertimos a array ordenado por nombre/número
        const arr = Array.from(map.values()).map((x) => {
            const h = x.habitacion;
            const nombre = h?.nombre ?? h?.numero ?? (h?.id != null ? `Habitación ${h.id}` : "Habitación");
            return {
                habitacionId: h?.id ?? null,
                nombre,
                ocupantes: x.ocupantes,
            };
        });

        arr.sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), "es"));

        return arr;
    }, [evento, personas, habitacionesCatalogo]);

    if (!rows.length) {
        return <div className={styles.hint}>No hay habitaciones asignadas en este evento.</div>;
    }

    return (
        <>
            {/* Header del tab */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 12,
                }}
            >
                <span className={styles.chip}>
                    {rows.length} habitación(es)
                </span>

                <button
                    type="button"
                    className={`${styles.btn} ${styles.ghost}`}
                    onClick={() => {
                        navigate(`/print/habitaciones?eventId=${evento?.id}`, {
                            state: { rows },
                        });
                    }}
                >
                    <IoPrintOutline style={{ fontSize: "15px" }} /> Imprimir
                </button>
            </div>

            <div className={styles["table-wrap"]}>
                <table className={styles["participaciones-table"]}>
                    <thead>
                        <tr>
                            <th>Habitación</th>
                            <th>Ocupantes</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => (
                            <tr key={r.habitacionId ?? r.nombre}>
                                <td>
                                    <strong>{r.nombre}</strong>
                                </td>
                                <td>
                                    {r.ocupantes.length ? (
                                        <ul style={{ margin: 0, paddingLeft: 18 }}>
                                            {r.ocupantes.map((o) => (
                                                <li key={o.id}>{o.label}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className={styles.muted}>—</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );

}